import { DAY_MONTH_YEAR } from '@/libs/filterDate'
import { CREATOR_CATEGORY_OPTIONS, DEFAULT_CONFIG } from '../creator-management/config'
import { parseDate } from '../creator-management/utils'
import './validationRules'

export const CAMPAIGN_LIST_STATUS = {
  pre_campaign: {
    label: 'Pre Campaign',
    tag: 'pre_campaign',
    style: {
      mainColor: '#4285F4',
      subColor: '#D9E7FD',
    },
  },
  ongoing: {
    label: 'OnGoing',
    tag: 'ongoing',
    style: {
      mainColor: '#34A770',
      subColor: '#DCF3EB',
    },
  },
  draft: {
    label: 'Draft',
    tag: 'draft',
    style: {
      mainColor: '#FBA63C',
      subColor: '#FCEBBE',
    },
  },
  ended: {
    label: 'Ended',
    tag: 'ended',
    style: {
      mainColor: '#C2C2C2',
      subColor: '#F4F4F4',
      textColor: '#333333',
    },
  },
  cancel: {
    label: 'Cancel',
    tag: 'cancel',
    style: {
      mainColor: '#E31A1A',
      subColor: '#FFEDED',
      textColor: '#333333',
    },
  },
}

export const CAMPAIGN_LIST_FILTER_OPTIONS = {
  end_date: {
    label: 'End Date',
    value: 'end_date',
    options: [
      { label: 'Ascending', value: 'asc' },
      { label: 'Descending', value: 'desc' },
    ],
  },
  name: {
    label: 'Nama Campaign',
    value: 'name',
    options: [
      { label: 'Ascending', value: 'asc' },
      { label: 'Descending', value: 'desc' },
    ],
  },
}

export const CAMPAIGN_LIST_TABLE_FIELDS = [
  { key: 'no', label: 'No', center: true },
  { key: 'name', label: 'Nama Campaign', tdAttr: { style: 'overflow-wrap: anywhere; max-w-[200px]' } },
  { key: 'campaign_type', label: 'Tipe Campaign', formatter: value => (value ? value.join(', ') : '-') },
  { key: 'product_category', label: 'Kategori' },
  { key: 'total_creators', label: 'Kuota Total Creator', formatter: value => value || '-' },
  { key: 'status', label: 'Status', formatter: value => value || '-' },
  { key: 'end_date', label: 'End Date', formatter: value => parseDate(value, DAY_MONTH_YEAR) },
].map(column => {
  const rest = {
    thStyle: { ...DEFAULT_CONFIG.thStyle },
    tdClass: DEFAULT_CONFIG.tdClass,
  }
  if (column.label === 'No') {
    rest.thStyle.minWidth = '50.3px'
  }
  if (column.center) {
    rest.thStyle.textAlign = 'center'
    rest.tdClass += ' text-center'
  }
  if (column.key === 'status') {
    rest.thStyle.width = '130px'
  }
  if (column.key === 'end_date') {
    rest.thStyle.width = '182px'
  }
  return { ...column, ...rest }
})

export const CAMPAIGN_DETAIL_FILTER_STATUS = [
  {
    label: 'Semua',
    value: undefined,
  },
  {
    label: 'Sesuai',
    value: 'sesuai',
  },
  {
    label: 'Kurang Sesuai',
    value: 'kurang_sesuai',
  },
]

export const ONGOING_CAMPAIGN_DETAIL_FILTER_STATUS = [
  {
    label: 'Semua',
    value: undefined,
  },
  {
    label: 'Uploaded',
    value: 'uploaded',
  },
  {
    label: 'Sample Received',
    value: 'sample_received',
  },
  {
    label: 'Reimbursement',
    value: 'reimbursement',
  },
]

export const CREATOR_CAMPAIGN_STATUS = {
  sesuai: {
    text: 'Sesuai',
    value: 'sesuai',
    style: {
      mainColor: '#34A770',
      subColor: '#DCF3EB',
    },
  },
  kurang_sesuai: {
    text: 'Tidak Sesuai',
    value: 'kurang_sesuai',
    style: {
      mainColor: '#E31A1A',
      subColor: '#FFEDED',
    },
  },
}

export const CREATOR_CAMPAIGN_STATUS_OPTIONS = [
  {
    text: 'Sesuai',
    value: 'sesuai',
  },
  {
    text: 'Kurang Sesuai',
    value: 'kurang_sesuai',
  },
]

export const CREATOR_CAMPAIGN_SAMPLE_STATUS = {
  diterima: {
    text: 'Diterima',
    value: 'diterima',
    style: {
      mainColor: '#34A770',
      subColor: '#DCF3EB',
    },
  },
  belum_diterima: {
    text: 'Belum Diterima',
    value: 'belum_diterima',
    style: {
      mainColor: '#E31A1A',
      subColor: '#FFEDED',
    },
  },
}

export const CREATOR_CAMPAIGN_SAMPLE_STATUS_OPTIONS = [
  {
    text: 'Ya',
    value: 'diterima',
  },
  {
    text: 'Belum Diterima',
    value: 'belum_diterima',
  },
]

export const CREATOR_CAMPAIGN_REIMBURSEMENT_STATUS = {
  ya: {
    text: 'Ya',
    value: 'ya',
    style: {
      mainColor: '#34A770',
      subColor: '#DCF3EB',
    },
  },
  tidak: {
    text: 'Tidak',
    value: 'tidak',
    style: {
      mainColor: '#E31A1A',
      subColor: '#FFEDED',
    },
  },
}

export const CREATOR_CAMPAIGN_REIMBURSEMENT_STATUS_OPTIONS = [
  { text: 'Ya', value: 'ya' },
  { text: 'Tidak', value: 'tidak' },
]

export const CREATOR_CAMPAIGN_PAID_OFF_STATUS = {
  true: {
    text: 'Ya',
    value: true,
    style: {
      mainColor: '#34A770',
      subColor: '#DCF3EB',
    },
  },
  false: {
    text: 'Tidak',
    value: false,
    style: {
      mainColor: '#E31A1A',
      subColor: '#FFEDED',
    },
  },
}

export const CREATOR_CAMPAIGN_PAID_OFF_STATUS_OPTIONS = [
  { text: 'Ya', value: true },
  { text: 'Tidak', value: false },
]

export const CAMPAIGN_DETAIL_TABLE_FIELDS = status => {
  const normalizedStatus = (status || '').replace(/\s/g, '_').toLowerCase()
  const isPre = normalizedStatus === 'pre_campaign' || normalizedStatus === 'cancel' || normalizedStatus === 'cancelled' || normalizedStatus === 'canceled' || normalizedStatus === 'draft'
  const isOngoing = normalizedStatus === 'ongoing' || normalizedStatus === 'ended'

  return [
    { key: 'no', label: 'No', center: true },
    { key: 'name', label: 'Nama Lengkap' },
    { key: 'category', label: 'Kategori' },
    { key: 'registered_date', label: 'Tanggal Register', formatter: value => parseDate(value, DAY_MONTH_YEAR) },
    isPre && { key: 'skala', label: 'Skala' },
    isPre && { key: 'status', label: 'Status', formatter: value => value || '-' },
    isOngoing && { key: 'uploaded', label: 'Uploaded Konten' },
    isOngoing && { key: 'sample', label: 'Sample Diterima' },
    isOngoing && { key: 'reimbursement', label: 'Reimbursement' },
    isOngoing && { key: 'paid_off', label: 'Terbayar' },
    { key: 'checkbox', label: 'Checkbox' },
  ].filter(Boolean).map(column => {
    const rest = {
      thStyle: { ...DEFAULT_CONFIG.thStyle },
      tdClass: DEFAULT_CONFIG.tdClass,
    }
    if (column.label === 'No') {
      rest.thClass = '!px-[8px]'
    }
    if (column.center) {
      rest.thStyle.textAlign = 'center'
      rest.tdClass += ' text-center'
    }
    if (column.key === 'status') {
      rest.thStyle.width = '135px'
    }
    if (column.key === 'registered_date') {
      rest.thStyle.width = '182px'
    }
    return { ...column, ...rest }
  })
}

export const CAMPAIGN_FORM_TAP = [
  {
    label: 'Komisi TAP (%)',
    key: 'commission_tap',
    type: 'number',
    placeholder: 'Contoh: 10',
    rules: 'required|numeric|min_value:1|max_value:100',
    customMessages: {
      required: 'Field ini wajib diisi.',
      min_value: 'Komisi TAP minimal 1%.',
      max_value: 'Komisi TAP maksimal 100%.',
    },
    prefix: '%',
  },
  {
    label: 'Komisi MCN (%)',
    key: 'commission_mcn',
    type: 'number',
    placeholder: 'Contoh: 10',
    rules: 'required|numeric|min_value:1|max_value:100',
    customMessages: {
      required: 'Field ini wajib diisi.',
      min_value: 'Komisi MCN minimal 1%.',
      max_value: 'Komisi MCN maksimal 100%.',
    },
    prefix: '%',
  },
]

export const CAMPAIGN_FORM_MCN = [
  {
    label: 'Komisi MCN (%)',
    key: 'commission_mcn',
    type: 'number',
    placeholder: 'Contoh: 10',
    rules: 'required|numeric|min_value:1|max_value:100',
    customMessages: {
      required: 'Field ini wajib diisi.',
      min_value: 'Komisi MCN minimal 1%.',
      max_value: 'Komisi MCN maksimal 100%.',
    },
    prefix: '%',
  },
]

export const CREATE_CAMPAIGN_FORM_FIELDS = [
  {
    label: 'Campaign Info',
    key: 'campaign_info',
    icon: 'k-note-21',
    inputs: [
      {
        label: 'Nama Campaign',
        key: 'name', // key: 'campaign_name',
        placeholder: 'Masukkan nama campaign',
        type: 'string',
        rules: 'required|max:100',
        customMessages: {
          required: 'Nama campaign wajib diisi.',
          max: 'Nama campaign maksimal 100 karakter.',
        },
      },
      {
        label: 'Deskripsi',
        key: 'description',
        placeholder: 'Masukkan deskripsi campaign',
        type: 'text',
        rules: 'required|max:700',
        customMessages: {
          required: 'Deskripsi wajib diisi.',
          max: 'Deskripsi maksimal 700 karakter.',
        },
      },
      {
        label: 'Link Product',
        key: 'product_link',
        placeholder: 'https://example.com/product',
        type: 'string',
        rules: 'required|product_url',
        customMessages: {
          required: 'Field ini wajib diisi.',
          product_url: 'Format URL produk tidak valid.',
        },
      },
      {
        label: 'Campaign Source',
        key: 'campaign_source',
        placeholder: 'Pilih campaign source',
        type: 'select',
        rules: 'required',
        customMessages: {
          required: 'Field ini wajib diisi.',
        },
        options: [
          {
            label: 'Created by Seller',
            value: 'Created by Seller',
          },
          {
            label: 'Created by Agency',
            value: 'Created by Agency',
          },
        ],
      },
      {
        label: 'Channel',
        key: 'channel',
        placeholder: 'Pilih channel',
        type: 'select',
        rules: 'required',
        customMessages: {
          required: 'Field ini wajib diisi.',
        },
        options: [
          {
            label: 'Umum (TAP & MCN)',
            value: 'Umum (TAP & MCN)',
          },
          {
            label: 'MCN Exclusive',
            value: 'MCN Exclusive',
          },
        ],
      },
      {
        label: 'Total Creator',
        key: 'total_creators',
        placeholder: 'Masukkan Kuota Total Creator',
        type: 'number',
        rules: 'required|numeric|min_value:1|max_value:10000',
        customMessages: {
          required: 'Field ini wajib diisi.',
          min_value: 'Total Creator minimal 1.',
          max_value: 'Total Creator maksimal 10.000.',
        },
      },
      {
        label: 'Minimum Followers',
        key: 'min_followers',
        placeholder: 'Masukkan minimum followers',
        type: 'number',
        rules: 'required|numeric|min_value:1|max_value:99000000',
        customMessages: {
          required: 'Field ini wajib diisi.',
          min_value: 'Minimal Followers 1.',
          max_value: 'Maksimal Followers 99.000.000.',
        },
      },
      {
        label: 'Minimum GMV',
        key: 'min_gmv',
        placeholder: 'Masukkan minimum GMV',
        type: 'number',
        rules: 'required|numeric|min_value:1|max_value:99000000',
        customMessages: {
          required: 'Field ini wajib diisi.',
          min_value: 'Minimal GMV 1.',
          max_value: 'Maksimal GMV 99.000.000.',
        },
      },
      {
        label: 'Domisili',
        key: 'domicile',
        type: 'multiselect',
        placeholder: 'Masukkan domisili',
        options: [],
        noSelectAll: true,
        prependOptions: [
          { label: 'Semua', value: 'Semua', uncheckOthers: true },
        ],
        optionLabel: item => `${item.city_name} · ${item.province_name}`,
        optionValue: item => `${item.city_name}, ${item.province_name}`,
      },
      {
        label: 'Jenis Produk',
        key: 'product_type',
        placeholder: 'Pilih jenis produk',
        type: 'select',
        rules: 'required',
        customMessages: {
          required: 'Field ini wajib diisi.',
        },
        options: [
          {
            label: 'Free',
            value: 'Free',
          },
          {
            label: 'Dipinjamkan',
            value: 'Dipinjamkan',
          },
        ],
      },
      {
        label: 'Thumbnail',
        key: 'thumbnail',
        type: 'image',
        rules: 'required|thumbnail_format_size|image_ratio:4,1',
        customMessages: {
          required: 'Field ini wajib diisi.',
          thumbnail_format_size: 'Format harus JPG/PNG maksimal 3 MB.',
          image_ratio: 'Rasio gambar harus 4:1.',
        },
        placeholder: 'Masukkan thumbnail',
      },
      {
        label: 'Kategori Produk',
        key: 'product_category',
        placeholder: 'Pilih kategori produk',
        type: 'multiselect',
        rules: 'required',
        customMessages: {
          required: 'Field ini wajib diisi.',
        },
        options: CREATOR_CATEGORY_OPTIONS.map(({ text, value }) => ({
          label: text,
          value,
        })),
      },
      {
        label: 'Tipe Campaign',
        key: 'campaign_type',
        placeholder: 'Pilih tipe campaign',
        type: 'multiselect',
        rules: 'required',
        customMessages: {
          required: 'Field ini wajib diisi.',
        },
        options: [
          {
            label: 'Free sample (barter)',
            value: 'Free sample (barter)',
          },
          {
            label: 'Paid campaign',
            value: 'Paid campaign',
          },
          {
            label: 'Add-on',
            value: 'Add-on',
          },
        ],
      },
      {
        type: 'group',
        children: [
          {
            label: 'Start Date',
            key: 'start_date',
            placeholder: 'Pilih tanggal mulai',
            type: 'date',
            rules: 'required',
            customMessages: {
              required: 'Field ini wajib diisi.',
            },
          },
          {
            label: 'End Date',
            key: 'end_date',
            placeholder: 'Pilih tanggal berakhir',
            type: 'date',
            rules: 'required|after_or_equal_date:@start_date',
            customMessages: {
              required: 'Field ini wajib diisi.',
              after_or_equal_date: 'End date harus setelah atau sama dengan start date.',
            },
          },
        ],
      },
    ],
  },
  {
    label: 'Scope of Works',
    key: 'scope_of_works',
    icon: 'k-briefcase',
    inputs: [
      {
        label: 'Tipe Konten',
        key: 'content_type',
        placeholder: 'Pilih tipe konten',
        type: 'select',
        rules: 'required',
        customMessages: {
          required: 'Field ini wajib diisi.',
        },
        options: [
          {
            label: 'Video',
            value: 'Video',
          },
          {
            label: 'Live',
            value: 'Live',
          },
        ],
      },
      {
        label: 'Jumlah Konten',
        key: 'content_amount',
        type: 'number',
        placeholder: 'Masukkan jumlah konten',
        rules: 'required|numeric|min_value:1|max_value:100',
        customMessages: {
          required: 'Field ini wajib diisi.',
          min_value: 'Jumlah Konten minimal 1.',
          max_value: 'Jumlah Konten maksimal 100.',
        },
      },
      {
        label: 'Brief Konten',
        key: 'content_brief',
        placeholder: 'Brief Konten',
        type: 'text',
        rules: 'max:500',
        customMessages: {
          max: 'Brief konten maksimal 500 karakter.',
        },
        footer: 'Contoh: 1 video tiktok dan 2 story blablabla ',
      },
    ],
  },
]

export const CREATOR_RECOMMENDATION_FIELDS = [
  { key: 'id', label: 'No', center: true },
  { key: 'name', label: 'Nama Lengkap' },
  { key: 'phone', label: 'Nomor HP', formatter: value => value?.replace(/^0?8/, '628') },
  { key: 'category', label: 'Kategori' },
  { key: 'created_at', label: 'Tanggal Register', formatter: value => (value ? DAY_MONTH_YEAR(value) : '-') },
  { key: 'skala', label: 'Skala', center: true },
].map(column => {
  const rest = {
    thStyle: { ...DEFAULT_CONFIG.thStyle },
    tdClass: DEFAULT_CONFIG.tdClass,
  }
  if (column.label === 'No') {
    rest.thStyle.minWidth = '44px'
  }
  if (column.center) {
    rest.thStyle.textAlign = 'center'
    rest.tdClass += ' text-center'
  }
  return { ...column, ...rest }
})
